import React, { Component } from 'react';
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import { FormattedMessage, FormattedNumber } from "react-intl";
import FormattedInputField from "../sharedComponents/formattedInputField.component.jsx";
import Toggle from "react-toggle";

class DefaultDiscount extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            contactId: this.props.contactId || '',
            contactType: this.props.contactType || 'persons',
            currency: this.props.currency,
            selectOptions: {
                "percent-before-taxes": "%",
                "currency-value": this.props.currency,
            },
            appliedDiscountValue: this.props.discountValue || '0',
            appliedDiscountType: this.props.discountType || 'percent-before-taxes',
            discountValue: this.props.discountValue || '0',
            discountType: this.props.discountType || 'percent-before-taxes',
            editable: this.props.editable || false,
            noSave: this.props.noSave || false,
            editMode: false,
            enabled: this.props.enabled,
            onChange: this.props.onChange || function () { },
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }


    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            contactId: nextProps.contactId || null,
            contactType: nextProps.contactType || 'persons',
            currency: nextProps.currency,
            selectOptions: {
                "percent-before-taxes": "%",
                "currency-value": nextProps.currency,
            },
            appliedDiscountValue: nextProps.discountValue || '0',
            appliedDiscountType: nextProps.discountType || 'percent-before-taxes',
            discountValue: nextProps.discountValue || '0',
            discountType: nextProps.discountType || 'percent-before-taxes',
            enabled: nextProps.enabled || false,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })

        if (!this.state.editMode) {
            this.setState({
                discountValue: this.state.appliedDiscountValue,
                discountType: this.state.appliedDiscountType
            })
        }
    }

    save(event) {
        event.preventDefault()
        let data = {
            discountValue: parseFloat(this.state.discountValue),
            discountType: this.state.discountType,
            enabled: this.state.enabled,
        }
        if (this.state.noSave) {
            this.state.onChange(data)
            this.setState({
                appliedDiscountValue: this.state.discountValue,
                appliedDiscountType: this.state.discountType,
                editMode: false,
            })
            return
        }
        AppContext.getApiClient().patch('/' + this.state.contactType + '/' + this.state.contactId, {
            defaultDiscount: data,
        }).then((r) => {
            this.state.onChange(r.attributes.defaultDiscount)
            this.setState({
                appliedDiscountValue: r.attributes.defaultDiscount.attributes.discountValue.toString(),
                appliedDiscountType: r.attributes.defaultDiscount.attributes.discountType,
                editMode: false,
            })
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    renderInput() {
        const lines = []
        lines.push(<div key={lines.length} className={'w-100 d-flex'}>
            <div className="mr-2">
                <Toggle
                    id={"enabled"}
                    defaultChecked={this.state.enabled}
                    checked={this.state.enabled}
                    icons={false}
                    onChange={() => { this.setState({ enabled: !this.state.enabled }) }} />
            </div>
            <label className="" htmlFor="sendEmail">
                <FormattedMessage
                    id="contacts.statement.recurring.options.enabled"
                    defaultMessage="Enabled"
                />
            </label>
        </div>)
        if (!this.state.enabled) {
            return lines
        }

        lines.push(<div className={"w-100 mb-1" + (this.state.editMode ? 'show' : '')}>
            <div className="w-100 d-flex" key="default-discount">
                <div className="col-3 p-1 pl-0">
                    <p className="m-0">
                        <FormattedInputField
                            type="text"
                            className="form-control"
                            placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                            onFocus={this.handleFocus}
                            valueType="decimal"
                            value={this.state.discountValue}
                            onValueChange={(newValue) => {
                                let discountType = this.state.discountType
                                if (!discountType || discountType === 'none') {
                                    discountType = 'percent-before-taxes'
                                }
                                this.setState({ discountValue: newValue, discountType: discountType })
                            }}
                        />
                    </p>
                </div>
                <div className="col-3 p-1">
                    <p className="m-0">
                        <select value={this.state.discountType}
                            className="custom-select"
                            onChange={(event) => { this.setState({ discountType: event.target.value }) }}
                        >
                            {Object.entries(this.state.selectOptions).map(([key, value]) => <option key={key} id={key} value={key}>{value}</option>)}
                        </select>
                    </p>
                </div>
            </div>
        </div >)

        return lines
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    render() {
        let text = '';
        let discount = '';
        let discountValue = '';

        if (this.state.appliedDiscountValue != 0 && this.state.enabled) {
            if (this.state.appliedDiscountType === 'currency-value') {
                discountValue = <FormattedNumber
                    style="currency"
                    currency={this.state.currency}
                    value={this.state.appliedDiscountValue}
                />
            } else {
                discountValue = <FormattedNumber
                    style="percent"
                    value={(parseFloat(this.state.appliedDiscountValue) / 100)}
                />
            }
            discount = discountValue
        } else {
            discount = <FormattedMessage
                id="customer.default_discount_none_label"
                defaultMessage="None"
            />
        }

        if (this.state.editable) {

            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {discount}  <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
            </a>

            text = <span>
                {link}
                <div className={"dropdown-menu p-4 w-100 top-inherit " + (this.state.editMode ? 'show' : '')}>
                    <div className="w-100 mb-1">
                        {this.renderInput()}
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </button>
                    </p>
                </div>
            </span>
        }

        return text
    }

}

export default DefaultDiscount





// WEBPACK FOOTER //
// ./src/customer/defaultDiscount.component.jsx